// Background "scenes" shown behind the (transparent) 3D canvas. These are pure CSS
// backgrounds — no image assets — so they're free to ship and work on every device.
// A custom photo backdrop can be supplied via ?backdrop=<url> (see App).

export interface Scene {
  label: string
  css: string
  /** True for dark scenes (used to lighten the contact shadow so it still reads). */
  dark?: boolean
}

export const SCENES: Record<string, Scene> = {
  studio: { label: 'Studio (light)', css: 'radial-gradient(circle at 50% 32%, #ffffff 0%, #d9dde3 120%)' },
  paper: { label: 'Paper', css: 'radial-gradient(circle at 50% 35%, #faf8f3 0%, #e4ddcd 120%)' },
  sky: { label: 'Sky', css: 'linear-gradient(180deg, #cfe2f6 0%, #7ea8d6 100%)' },
  warm: { label: 'Warm', css: 'radial-gradient(circle at 50% 30%, #f6ede0 0%, #d9b894 120%)' },
  slate: { label: 'Slate (dark)', css: 'radial-gradient(circle at 50% 30%, #4d5663 0%, #1b212a 120%)', dark: true },
  graphite: { label: 'Graphite', css: 'radial-gradient(circle at 50% 35%, #2c313a 0%, #0c0e12 120%)', dark: true },
  spotlight: { label: 'Spotlight', css: 'radial-gradient(circle at 50% 26%, #7a828f 0%, #11141a 92%)', dark: true },
  navy: { label: 'Navy', css: 'radial-gradient(circle at 50% 30%, #20407a 0%, #0a1426 120%)', dark: true },
}

export const DEFAULT_SCENE = 'studio'

export const SCENE_NAMES = Object.keys(SCENES)
